import { render, staticRenderFns } from "./RequestsNew.vue?vue&type=template&id=1548c736&scoped=true"
import script from "./RequestsNew.vue?vue&type=script&lang=ts"
export * from "./RequestsNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestsNew.vue?vue&type=style&index=0&id=1548c736&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548c736",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1548c736')) {
      api.createRecord('1548c736', component.options)
    } else {
      api.reload('1548c736', component.options)
    }
    module.hot.accept("./RequestsNew.vue?vue&type=template&id=1548c736&scoped=true", function () {
      api.rerender('1548c736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/RequestsNew.vue"
export default component.exports